/*
 * Application Insights JavaScript SDK - Common, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims";
import { EventData } from "../Interfaces/Contracts/Generated/EventData";
import { dataSanitizeString, dataSanitizeProperties, dataSanitizeMeasurements } from "./Common/DataSanitizer";
import { strNotSpecified } from "../Constants";

var Event =
/** @class */
function (_super) {
  __extends(Event, _super);
  /**
   * Constructs a new instance of the EventTelemetry object
   */


  function Event(logger, name, properties, measurements) {
    var _this = _super.call(this) || this;

    _this.aiDataContract = {
      ver: 1
      /* Required */
      ,
      name: 1
      /* Required */
      ,
      properties: 0
      /* Default */
      ,
      measurements: 0
      /* Default */

    };
    _this.name = dataSanitizeString(logger, name) || strNotSpecified;
    _this.properties = dataSanitizeProperties(logger, properties);
    _this.measurements = dataSanitizeMeasurements(logger, measurements);
    return _this;
  }

  Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
  Event.dataType = "EventData";
  return Event;
}(EventData);

export { Event };